cv.TeamDonationsView = Marionette.LayoutView.extend({
  template: cv.Templates['team/donations'],

  regions : {
    table : '.table-list'
  },

  behaviors: [{
    behaviorClass : cv.PaginateBehavior
  }],

  events : {
  },

  initialize: function(options){
    this.options = _.extend(this.options, options);

    console.log('TeamDonationsView initialized.');
  },

  onAttach: function(){
    this.showChildView('table', new cv.TableView({
      collection : this.collection,
      row_heading_tpl : 'team/donations_row_heading',
      row_view : cv.TeamDonationsRowView,
      row_type : 'donations',
      row_empty_data : {
        image : '<i class="fa fa-credit-card"></i>',
        message : 'No donations have been made to this team.'
      }
    }));
  }
});
